var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('b-img',{attrs:{"src":require('/src/assets/login-logo.png'),"fluid":"","center":"","alt":"app logo"}}),_c('gender-comp'),_c('bio-comp'),_c('likes-comp'),_c('dislikes-comp'),_c('div',{attrs:{"id":"button"},on:{"click":_vm.forward}},[_vm._v("Next")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }